import _sfc_main from "./component-library95.mjs";
import "./component-library96.mjs";
import normalizeComponent from "./component-library82.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("span", { staticClass: "price", class: _setup.classes }, [_vm.preText ? _c("span", { staticClass: "price__pre-text", class: _setup.preTextClasses, domProps: { "innerHTML": _vm._s(_vm.preText) } }) : _vm._e(), _c("span", { staticClass: "price__amount", class: _setup.priceClasses }, [_vm._v(" " + _vm._s(_vm.amount) + " ")]), _vm.postText ? _c("span", { staticClass: "price__post-text", domProps: { "innerHTML": _vm._s(_vm.postText) } }) : _vm._e()]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "9150c926",
  null,
  null
);
const Price = __component__.exports;
export {
  Price as default
};
